import { propNames } from "@chakra-ui/styled-system";
import { memoizeOne } from "@chakra-ui/utils";
import isValid from "@emotion/is-prop-valid";

function createShouldForwardProp(props) {
  var regex = new RegExp("^(" + props.join("|") + ")$");
  return memoizeOne(prop => {
    var cond1 = isValid(prop) && !regex.test(prop);
    var cond2 = ["htmlWidth", "htmlHeight", "htmlSize"].includes(prop);
    return cond1 || cond2;
  });
}

export var shouldForwardProp = createShouldForwardProp(propNames);
//# sourceMappingURL=should-forward-prop.js.map